import React, { Component } from 'react'
import PropTypes from 'prop-types'
import pick from 'lodash/pick'
import isEqual from 'lodash/isEqual'
import { BoardDiv } from '../../styles/Base'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Lane from './Lane'
import { Container, Draggable } from 'react-smooth-dnd'
import { dispatch } from '@rematch/core';
import * as boardActions from '../actions/BoardActions'
import * as laneActions from '../actions/LaneActions'

class BoardContainer extends Component {
  wireEventBus = () => {
    const { actions, eventBusHandle, id } = this.props;
    const thisObject = this;
    const getCard = function (laneId, cardId) {
      let cardsToReturn = null;
      const lanes = thisObject.props.reducerData.lanes;
      lanes.map(lane => {
        if (lane._id === laneId) {
          const cards = lane.cards.filter(card => card._id === cardId)
          cardsToReturn = cards;
        }
      })
      return cardsToReturn;
    }

    let eventBus = {
      publish: event => {
        switch (event.type) {
          case "GET_CARD":
            return getCard(event.laneId, event.cardId);
          case 'ADD_CARD':
            return actions.addCard({ laneId: event.laneId, card: event.card })
          case 'REMOVE_CARD':
            return actions.removeCard({ laneId: event.laneId, cardId: event.cardId })
          case 'REFRESH_BOARD':
            return actions.loadBoard(event.data)
          case 'MOVE_CARD':
            return actions.moveCardAcrossLanes({
              fromLaneId: event.fromLaneId,
              toLaneId: event.toLaneId,
              cardId: event.cardId,
              index: event.index
            })
          case 'UPDATE_LANES':
            return actions.updateLanes(event.lanes)
        }
      }
    }
    eventBusHandle[id] = eventBus;
  }

  componentWillMount() {
    const { actions, eventBusHandle, id } = this.props;
    const { lanes } = this.props.data;
    const data = {
      lanes: lanes,
      boardId: id,
      eventBusHandle: eventBusHandle
    };
    dispatch.lifeCycle.setEventBusHandle(eventBusHandle);
    actions.loadBoard(data)
    if (eventBusHandle) {
      this.wireEventBus();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { data, reducerData, onDataChange } = this.props
    if (nextProps.reducerData && !isEqual(reducerData, nextProps.reducerData)) {
      onDataChange(nextProps.reducerData)
    }
    if (nextProps.data && !isEqual(nextProps.data, data)) {
      const data = {
        lanes: nextProps.data.lanes,
        boardId: this.props.id,
        eventBusHandle: this.props.eventBusHandle
      };
      this.props.actions.loadBoard(data);
      if (this.props.eventBusHandle) {
        this.wireEventBus();
      }
      onDataChange(nextProps.data);
    }
    if (
      nextProps.selectedPracticeFlowActivity &&
      reducerData.lanes &&
      reducerData.lanes.length > 0
    ) {
      reducerData.lanes = reducerData.lanes.map((activity) =>
        activity._id === nextProps.selectedPracticeFlowActivity._id
          ? {
              ...activity,
              integration: nextProps.selectedPracticeFlowActivity.integration,
            }
          : activity
      );
    }
  }

  getCardDetails = (laneId, cardIndex) => {
    return this.props.reducerData.lanes.find(lane => lane._id === laneId).cards[cardIndex];
    // return data;
  }

  onDragStart = async ({ payload }) => {
    if (payload.type === "activity") {
      await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
      dispatch.lifeCycle.showResourecePane(null);
    }
    const { handleLaneDragStart } = this.props;
    if (payload) {
      handleLaneDragStart(payload.id);
    }

  }

  onLaneDrop = ({ removedIndex, addedIndex, payload }) => {
    const { actions, handleLaneDragEnd } = this.props
    actions.moveLane({ oldIndex: removedIndex, newIndex: addedIndex })
    handleLaneDragEnd(payload.id, addedIndex);
    dispatch.createPack.changeActivityIndex({ nodeToMove: payload, target: payload.parentActivity, indexInTarget: addedIndex, selectedPracticeLibrary: this.props.selectedPracticeLibrary._id });
  }

  getLaneDetails = index => {
    return this.props.reducerData.lanes[index]
  }

  render() {
    const { id, reducerData, draggable, laneDraggable, laneDragClass, style, ...otherProps } = this.props;
    const boardId = id;
    // Stick to whitelisting attributes to segregate board and lane props
    const passthroughProps = pick(this.props, [
      'onLaneScroll',
      'onCardClick',
      'onCardDelete',
      'onCardAdd',
      'onLaneClick',
      'addCardLink',
      'laneSortFunction',
      'draggable',
      'cardDraggable',
      'collapsibleLanes',
      'editable',
      'hideCardDeleteIcon',
      'customCardLayout',
      'newCardTemplate',
      'customLaneHeader',
      'tagStyle',
      'handleDragStart',
      'handleDragEnd',
      'cardDragClass',
      'children'
    ])
    let height = this.props.componentDesignerDimension;
    //let setHeight = (height.windowHeight - height.height) - 130;
    return (
      <BoardDiv style={{ width: "100%" }} {...otherProps} draggable={false}>
        <Container
          orientation="horizontal"
          onDragStart={this.onDragStart}
          dragClass={laneDragClass}
          onDrop={this.onLaneDrop}
          lockAxis={'x'}
          style={{"cursor":"pointer"}}
          classNAme="overflow-hide"
          getChildPayload={index => this.getLaneDetails(index)}
          groupName={`TrelloBoard${id}`}>
          {
            reducerData && reducerData.lanes.map((lane, index) => {
            const { _id, droppable, ...otherProps } = lane;
            let stageData;
            let phaseData = this.props.selectedPracticeLibrary.activities.map((phase)=>{
              if( phase._id===lane.parentActivity){
                stageData=phase.activities.filter((stage)=>{
                  return stage._id===lane.stageId
                })
              }
            })
            const laneToRender = (
              <Lane
                key={_id}
                id={_id}
                boardId={boardId}
                getCardDetails={this.getCardDetails}
                index={index}
                objectId={_id}
                droppable={droppable === undefined ? true : droppable}
                {...otherProps}
                {...passthroughProps}
                stageData={stageData&& stageData.length>0 && stageData[0]}
                selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                user={this.props.user}
                graph={this.props.graph}
                addEdge={this.props.addEdge}
                removeEdge={this.removeEdge}
                {...this.props}
                enableLinkActivity={this.props.enableLinkActivity}
              />
            )
            return draggable && laneDraggable ? (
              <Draggable key={lane._id}>{laneToRender}</Draggable>
            ) : (
              <div
                style={{
                  "height": "100%",
                  "display": "inline-block",
                  "vertical-align": "top",
                  "white-space": "normal"
                }}
                key={lane._id}>{laneToRender}</div>
            )
            })
          }
        </Container>
      </BoardDiv>
    )
  }
}

BoardContainer.propTypes = {
  id: PropTypes.string,
  key: PropTypes.string,
  actions: PropTypes.object,
  data: PropTypes.object.isRequired,
  reducerData: PropTypes.object,
  onDataChange: PropTypes.func,
  eventBusHandle: PropTypes.object,
  onLaneScroll: PropTypes.func,
  onCardClick: PropTypes.func,
  onCardDelete: PropTypes.func,
  onCardAdd: PropTypes.func,
  addCardLink: PropTypes.node,
  onLaneClick: PropTypes.func,
  laneSortFunction: PropTypes.func,
  draggable: PropTypes.bool,
  collapsibleLanes: PropTypes.bool,
  editable: PropTypes.bool,
  hideCardDeleteIcon: PropTypes.bool,
  handleDragStart: PropTypes.func,
  handleDragEnd: PropTypes.func,
  handleLaneDragStart: PropTypes.func,
  handleLaneDragEnd: PropTypes.func,
  customCardLayout: PropTypes.bool,
  newCardTemplate: PropTypes.node,
  customLaneHeader: PropTypes.element,
  style: PropTypes.object,
  tagStyle: PropTypes.object,
  laneDraggable: PropTypes.bool,
  cardDraggable: PropTypes.bool,
  cardDragClass: PropTypes.string,
  laneDragClass: PropTypes.string
}

BoardContainer.defaultProps = {
  onDataChange: () => { },
  handleDragStart: () => { },
  handleDragEnd: () => { },
  handleLaneDragStart: () => { },
  handleLaneDragEnd: () => { },
  editable: false,
  hideCardDeleteIcon: false,
  draggable: false,
  collapsibleLanes: false,
  laneDraggable: true,
  cardDraggable: true,
  cardDragClass: 'react_trello_dragClass',
  laneDragClass: 'react_trello_dragLaneClass'
}

const mapStateToProps = state => {
  if (!state) {
    return {}
  }
  return state.lanes ? { reducerData: state } : {}
}

const mapDispatchToProps = dispatch => ({ actions: bindActionCreators({ ...boardActions, ...laneActions }, dispatch) })

export default connect(mapStateToProps, mapDispatchToProps)(BoardContainer)
